import { render, staticRenderFns } from "./ParentTasksView.vue?vue&type=template&id=45bd9574&"
import script from "./ParentTasksView.vue?vue&type=script&lang=js&"
export * from "./ParentTasksView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports